import Service from '@ember/service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import {
  convertToLocalDate,
  convertToLocalDatetime,
  convertToLocalTime,
  convertToTimeZone,
} from 'my-phorest/utils/local-datetime-helpers';

export default class BranchTimeService extends Service {
  @service intl;
  @service session;
  @service timers;

  @tracked now;
  @tracked _today;

  constructor() {
    super(...arguments);
    this.updateCurrentTime();

    this.timers.registerTimer({
      action: () => {
        this.updateCurrentTime();
      },
      every: 1000,
      destroyable: this,
    });
  }

  updateCurrentTime() {
    const currentTime = new Date().toISOString();
    this.now = convertToTimeZone(currentTime, this.session.branchTimeZone);
    this.today = convertToLocalDate(this.now);
  }

  get time() {
    return convertToLocalTime(this.now);
  }

  set today(newValue) {
    if (this._today !== newValue) {
      this._today = newValue;
    }
  }

  get today() {
    return this._today;
  }

  get dateAndTime() {
    return convertToLocalDatetime(this.now);
  }
}
